// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%239aa0a6%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: 'Inter';
}

h2 {
    text-align: center;
    font-size: 1.3rem;
    font-weight: 500;
    color: #18316E;
}

.styles_container__dIpCo {
    padding: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.styles_containerSwitch__RxcF4 {
    display: flex;
    align-items: center;
}

.styles_labelSwitch__mfdr1 {
    font-size: 1rem;
    font-weight: 300;
    color: #9b9b9b;
}

/* Lista de grupos — alinhado ao protótipo HTML (Taxation Mind) */
.styles_pageWrapper__HGjrx {
  min-height: 100vh;
  padding: 24px 0;
}

.styles_pageRoot__opVtA {
  margin: 0 2rem;
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #f5f5f5;
  padding: 24px;
  border-radius: 12px;
}

.styles_formPageWrapper__kLLMJ {
  padding: 24px 0;
}

.styles_formPageRoot__oJlu0 {
  padding-top: 24px;
  padding-bottom: 24px;
}

@media (max-width: 780px) {
  .styles_pageRoot__opVtA {
    margin: 0 1rem;
    padding: 16px;
  }

  .styles_formPageRoot__oJlu0 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
}

.styles_inner__RvPWq {
  max-width: none;
  width: 100%;
  margin: 0 auto;
}

.styles_mainPad__HKSh0 {
  padding-top: 0;
}

.styles_breadcrumb__mZbSY {
  padding: 12px 24px;
  font-size: 13px;
  color: #80868b; /* gray-600 */
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border-bottom: 1px solid #e8eaed; /* gray-200 */
  border-radius: 12px;
  margin-bottom: 24px;
}

@media (max-width: 780px) {
  .styles_breadcrumb__mZbSY {
    padding: 12px 16px;
  }
}

.styles_crumbLink__8IHFl {
  color: #1a73e8; /* blue-500 */
  text-decoration: none;
  font-weight: 500;
}

.styles_crumbText__-6mvk {
  color: #5f6368; /* gray-700 */
  font-weight: 500;
}

.styles_crumbLink__8IHFl:hover {
  text-decoration: underline;
}

.styles_breadcrumbSep__qwyIi {
  color: #bdc1c6; /* gray-400 */
}

.styles_pageHeader__ZgI\\+c {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 1rem;
}

.styles_pageTitle__ZZnuM {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 26px;
  font-weight: 600;
  color: #1b3a5f;
  letter-spacing: -0.3px;
  margin: 0;
}

.styles_pageTitleIcon__vA3ke {
  font-size: 32px !important;
  color: #1b3a5f;
}

.styles_statsGrid__F1hIn {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

@media (max-width: 1024px) {
  .styles_statsGrid__F1hIn {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .styles_statsGrid__F1hIn {
    grid-template-columns: 1fr;
  }
}

.styles_statCard__84Ka4 {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);
}

.styles_statIcon__0al4m {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.styles_statIcon__0al4m svg {
  font-size: 22px;
}

.styles_statInfo__tdVLL {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.styles_statValue__b9OZe {
  font-size: 24px;
  font-weight: 600;
  color: #202124;
  line-height: 1;
}

.styles_statLabel__okPNL {
  font-size: 13px;
  color: #9aa0a6; /* gray-500 */
  font-weight: 500;
}

.styles_contentCard__YwLMS {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);
  overflow: hidden;
}

.styles_mainCard__8BmCp {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);
  overflow: hidden;
}

.styles_filtersBar__3nrSb {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaed; /* gray-200 */
}

.styles_filterGroup__aSZVQ {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.styles_filterGroup__aSZVQ label {
  font-size: 13px;
  color: #80868b; /* gray-600 */
  font-weight: 400;
  white-space: nowrap;
}

.styles_select__82XnX {
  padding: 8px 12px;
  border: 1px solid #dadce0; /* gray-300 */
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  color: #3c4043; /* gray-800 */
  background: #ffffff;
  min-width: 160px;
}

.styles_select__82XnX:focus {
  outline: none;
  border-color: #1a73e8; /* blue-500 */
}

.styles_searchInput__jfrqM {
  width: 100%;
  min-width: 280px;
  padding: 8px 12px 8px 36px;
  border: 1px solid #dadce0; /* gray-300 */
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  color: #3c4043; /* gray-800 */
  background: #ffffff
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat 10px center;
  background-size: 18px;
}

.styles_searchInput__jfrqM:focus {
  outline: none;
  border-color: #1a73e8; /* blue-500 */
}

.styles_groupsGrid__MJfok {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  padding: 20px;
}

@media (max-width: 768px) {
  .styles_groupsGrid__MJfok {
    grid-template-columns: 1fr;
  }
}

.styles_groupCard__T8qFt {
  border: 1px solid #e8eaed; /* gray-200 */
  border-radius: 12px;
  padding: 20px;
  transition: all 0.15s ease;
  position: relative;
  background: #ffffff;
}

.styles_groupCard__T8qFt:hover {
  border-color: #1a73e8; /* blue-500 */
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);
}

.styles_groupCardInactive__JTk2k {
  opacity: 0.6;
}

.styles_groupStatus__iYHpI {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
}

.styles_statusBadge__D2XSP {
  display: inline-block;
  padding: 0.25rem 0.625rem;
  border-radius: 14px;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.styles_statusBadgeActive__lI9\\+n {
  background: #e6f4ea;
  color: #34a853;
}

.styles_statusBadgeInactive__OZa1o {
  background: #e8eaed; /* gray-200 */
  color: #80868b; /* gray-600 */
}

.styles_groupHeader__\\+MWJ\\+ {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
}

.styles_groupIcon__VTQ1y {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.styles_groupIcon__VTQ1y svg {
  font-size: 26px;
}

.styles_groupName__ThPXF {
  font-size: 1.0625rem;
  font-weight: 600;
  color: #202124;
  margin-bottom: 0.25rem;
  line-height: 1.3;
}

.styles_groupDesc__gEUfg {
  font-size: 13px;
  color: #9aa0a6; /* gray-500 */
  line-height: 1.4;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.styles_groupStats__IZNEY {
  display: flex;
  gap: 20px;
  padding-top: 16px;
  border-top: 1px solid #e8eaed; /* gray-200 */
}

.styles_groupStat__cER9C {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
  color: #5f6368;
}

.styles_groupStat__cER9C svg {
  font-size: 18px;
}

.styles_groupStat__cER9C strong {
  color: #202124;
  font-weight: 600;
}

.styles_groupStatsNivel__WbO2I {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-top: 8px;
}

.styles_accessLevelTag__8M-h5 {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 2px 8px;
  background: #ede7f6; /* purple-100 */
  color: #673ab7; /* purple-500 */
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
}

.styles_groupActions__kDHoi {
  display: flex;
  gap: 0.5rem;
  flex-wrap: nowrap;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e8eaed; /* gray-200 */
}

.styles_groupActions__kDHoi > * {
  flex: 1 1;
  min-width: 0;
}

.styles_groupActions__kDHoi .MuiButton-root {
  width: 100%;
  min-width: 0;
  white-space: nowrap;
}

.styles_groupActions__kDHoi .MuiButton-startIcon {
  margin-right: 6px;
}

.styles_emptyState__gEJV8 {
  text-align: center;
  padding: 3rem 1rem;
  color: #80868b;
  grid-column: 1 / -1;
}

.styles_emptyState__gEJV8 h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #5f6368;
  margin: 0.5rem 0;
}

.styles_emptyState__gEJV8 p {
  font-size: 0.875rem;
  color: #80868b;
  margin: 0;
}

.styles_paginationWrap__vFdwa {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}

/* =========================
   Formulário (Novo/Editar)
   ========================= */
.styles_formMain__1RE4S {
  padding: 2px 0 8px; /* rodapé sticky como na tela de Usuários */
  max-width: none;
  width: 100%;
  margin: 0 auto;
}

.styles_formTitleRow__4rVd3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.styles_formTitle__XZHaH {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1b3a5f;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.3px;
  margin: 0;
}

.styles_formCard__34UWZ {
  border-radius: 12px !important;
  border-color: #e8eaed !important;
  background: #ffffff !important;
  overflow: hidden;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);
}

.styles_formCardHeader__YdmbE {
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaed;
  font-size: 15px;
  font-weight: 500;
  color: #3c4043;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f9fa; /* gray-50 */
}

.styles_formCardHeader__YdmbE svg {
  color: #1b3a5f;
}

.styles_formHeaderBadge__OL\\+xW {
  margin-left: auto;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background: #e8f0fe;
  color: #1a73e8;
}

.styles_formCardBody__wLovj {
  padding: 20px;
}

.styles_permissionsCard__881QJ {
  border-radius: 12px !important;
  border-color: #e8eaed !important;
  background: #ffffff !important;
  overflow: hidden;
  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);
  height: auto;
  min-height: 520px;
  display: flex;
  flex-direction: column;
}

.styles_permissionsHeader__ZpPdC {
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fafafa;
}

.styles_permissionsTitle__J1BEQ {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #1b3a5f;
}

.styles_permissionsTitle__J1BEQ svg {
  color: #1b3a5f;
}

.styles_permissionsHeaderRight__GhpTj {
  display: flex;
  align-items: center;
  gap: 8px;
}

.styles_permissionsHeaderBadge__Mr7Ok {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 16px;
  background: #e3f2fd;
  color: #1976d2;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.styles_permissionsTopbar__PHIC9 {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: #fafafa;
  border-bottom: 1px solid #eeeeee;
}

.styles_permissionsTopbarRight__ZbAbi {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.styles_permissionsSelectedText__3eoA7 {
  color: #5f6368;
  font-size: 14px;
  font-weight: 400;
}

/* Barra de status + Limpar Tudo (abaixo da lista de permissões) */
.styles_permissionsToolbar__EIDA5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f1f3f4;
  border-top: 1px solid #e8eaed;
}

.styles_permissionsToolbarInfo__atRoN {
  font-size: 14px;
  color: #5f6368;
  font-weight: 400;
}

.styles_outlineMiniBtn__qdjL6 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #dadce0;
  background: #ffffff;
  color: #3c4043;
  cursor: pointer;
  font-size: 13px;
  font-family: inherit;
  font-weight: 500;
}

.styles_outlineMiniBtn__qdjL6:disabled {
  cursor: default;
  opacity: 0.55;
}

.styles_outlineMiniBtnIcon__u5KTi {
  font-size: 18px !important;
  width: 18px;
  height: 18px;
  color: #3c4043;
  flex-shrink: 0;
}

.styles_outlineMiniBtn__qdjL6:hover {
  background: #f8f9fa;
  border-color: #bdc1c6;
}

.styles_actionFooter__NWQyK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: #ffffff;
  border-top: 1px solid #e8eaed;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.1);
}

.styles_footerInfoBar__zib5j {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 0;
}

.styles_footerStat__DK5ly {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.styles_footerStatLabel__hiEkV {
  font-size: 12px;
  color: #80868b;
}

.styles_footerStatValue__peLZ3 {
  font-size: 13px;
  color: #202124;
  max-width: 380px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.styles_footerActions__WHT7o {
  display: flex;
  gap: 12px;
}

@media (max-width: 1200px) {
  .styles_footerInfoBar__zib5j {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GruposUsuarios/styles.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,iEAAiE;AACjE;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uFAAuF;EACvF,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc,EAAE,aAAa;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gCAAgC,EAAE,aAAa;EAC/C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,aAAa;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6EAA6E;EAC7E,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6EAA6E;EAC7E,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC,EAAE,aAAa;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,aAAa;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB,EAAE,aAAa;EACxC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc,EAAE,aAAa;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,aAAa;AACtC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB,EAAE,aAAa;EACxC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc,EAAE,aAAa;EAC7B;;yBAEuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,aAAa;AACtC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB,EAAE,aAAa;EACpC,6EAA6E;AAC/E;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB,EAAE,aAAa;EAClC,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,aAAa;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6BAA6B,EAAE,aAAa;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB,EAAE,eAAe;EACpC,cAAc,EAAE,eAAe;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B,EAAE,aAAa;AAC9C;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;8BAE8B;AAC9B;EACE,kBAAkB,EAAE,2CAA2C;EAC/D,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB,EAAE,YAAY;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,6EAA6E;EAC7E,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["* {\n    font-family: 'Inter';\n}\n\nh2 {\n    text-align: center;\n    font-size: 1.3rem;\n    font-weight: 500;\n    color: #18316E;\n}\n\n.container {\n    padding: 0.5rem;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.containerSwitch {\n    display: flex;\n    align-items: center;\n}\n\n.labelSwitch {\n    font-size: 1rem;\n    font-weight: 300;\n    color: #9b9b9b;\n}\n\n/* Lista de grupos — alinhado ao protótipo HTML (Taxation Mind) */\n.pageWrapper {\n  min-height: 100vh;\n  padding: 24px 0;\n}\n\n.pageRoot {\n  margin: 0 2rem;\n  box-sizing: border-box;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background: #f5f5f5;\n  padding: 24px;\n  border-radius: 12px;\n}\n\n.formPageWrapper {\n  padding: 24px 0;\n}\n\n.formPageRoot {\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n\n@media (max-width: 780px) {\n  .pageRoot {\n    margin: 0 1rem;\n    padding: 16px;\n  }\n\n  .formPageRoot {\n    padding-top: 16px;\n    padding-bottom: 16px;\n  }\n}\n\n.inner {\n  max-width: none;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.mainPad {\n  padding-top: 0;\n}\n\n.breadcrumb {\n  padding: 12px 24px;\n  font-size: 13px;\n  color: #80868b; /* gray-600 */\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #ffffff;\n  border-bottom: 1px solid #e8eaed; /* gray-200 */\n  border-radius: 12px;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 780px) {\n  .breadcrumb {\n    padding: 12px 16px;\n  }\n}\n\n.crumbLink {\n  color: #1a73e8; /* blue-500 */\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.crumbText {\n  color: #5f6368; /* gray-700 */\n  font-weight: 500;\n}\n\n.crumbLink:hover {\n  text-decoration: underline;\n}\n\n.breadcrumbSep {\n  color: #bdc1c6; /* gray-400 */\n}\n\n.pageHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.pageTitle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 26px;\n  font-weight: 600;\n  color: #1b3a5f;\n  letter-spacing: -0.3px;\n  margin: 0;\n}\n\n.pageTitleIcon {\n  font-size: 32px !important;\n  color: #1b3a5f;\n}\n\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 1024px) {\n  .statsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .statsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.statCard {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);\n}\n\n.statIcon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.statIcon svg {\n  font-size: 22px;\n}\n\n.statInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.statValue {\n  font-size: 24px;\n  font-weight: 600;\n  color: #202124;\n  line-height: 1;\n}\n\n.statLabel {\n  font-size: 13px;\n  color: #9aa0a6; /* gray-500 */\n  font-weight: 500;\n}\n\n.contentCard {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);\n  overflow: hidden;\n}\n\n.mainCard {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);\n  overflow: hidden;\n}\n\n.filtersBar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e8eaed; /* gray-200 */\n}\n\n.filterGroup {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filterGroup label {\n  font-size: 13px;\n  color: #80868b; /* gray-600 */\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n.select {\n  padding: 8px 12px;\n  border: 1px solid #dadce0; /* gray-300 */\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n  color: #3c4043; /* gray-800 */\n  background: #ffffff;\n  min-width: 160px;\n}\n\n.select:focus {\n  outline: none;\n  border-color: #1a73e8; /* blue-500 */\n}\n\n.searchInput {\n  width: 100%;\n  min-width: 280px;\n  padding: 8px 12px 8px 36px;\n  border: 1px solid #dadce0; /* gray-300 */\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n  color: #3c4043; /* gray-800 */\n  background: #ffffff\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%239aa0a6' viewBox='0 0 24 24'%3E%3Cpath d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'/%3E%3C/svg%3E\")\n    no-repeat 10px center;\n  background-size: 18px;\n}\n\n.searchInput:focus {\n  outline: none;\n  border-color: #1a73e8; /* blue-500 */\n}\n\n.groupsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .groupsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.groupCard {\n  border: 1px solid #e8eaed; /* gray-200 */\n  border-radius: 12px;\n  padding: 20px;\n  transition: all 0.15s ease;\n  position: relative;\n  background: #ffffff;\n}\n\n.groupCard:hover {\n  border-color: #1a73e8; /* blue-500 */\n  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);\n}\n\n.groupCardInactive {\n  opacity: 0.6;\n}\n\n.groupStatus {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n}\n\n.statusBadge {\n  display: inline-block;\n  padding: 0.25rem 0.625rem;\n  border-radius: 14px;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.statusBadgeActive {\n  background: #e6f4ea;\n  color: #34a853;\n}\n\n.statusBadgeInactive {\n  background: #e8eaed; /* gray-200 */\n  color: #80868b; /* gray-600 */\n}\n\n.groupHeader {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.groupIcon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.groupIcon svg {\n  font-size: 26px;\n}\n\n.groupName {\n  font-size: 1.0625rem;\n  font-weight: 600;\n  color: #202124;\n  margin-bottom: 0.25rem;\n  line-height: 1.3;\n}\n\n.groupDesc {\n  font-size: 13px;\n  color: #9aa0a6; /* gray-500 */\n  line-height: 1.4;\n  display: -webkit-box;\n  line-clamp: 2;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.groupStats {\n  display: flex;\n  gap: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e8eaed; /* gray-200 */\n}\n\n.groupStat {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.8125rem;\n  color: #5f6368;\n}\n\n.groupStat svg {\n  font-size: 18px;\n}\n\n.groupStat strong {\n  color: #202124;\n  font-weight: 600;\n}\n\n.groupStatsNivel {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding-top: 8px;\n}\n\n.accessLevelTag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 2px 8px;\n  background: #ede7f6; /* purple-100 */\n  color: #673ab7; /* purple-500 */\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.groupActions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: nowrap;\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #e8eaed; /* gray-200 */\n}\n\n.groupActions > * {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.groupActions :global(.MuiButton-root) {\n  width: 100%;\n  min-width: 0;\n  white-space: nowrap;\n}\n\n.groupActions :global(.MuiButton-startIcon) {\n  margin-right: 6px;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #80868b;\n  grid-column: 1 / -1;\n}\n\n.emptyState h3 {\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: #5f6368;\n  margin: 0.5rem 0;\n}\n\n.emptyState p {\n  font-size: 0.875rem;\n  color: #80868b;\n  margin: 0;\n}\n\n.paginationWrap {\n  display: flex;\n  justify-content: center;\n  padding-top: 1.5rem;\n}\n\n/* =========================\n   Formulário (Novo/Editar)\n   ========================= */\n.formMain {\n  padding: 2px 0 8px; /* rodapé sticky como na tela de Usuários */\n  max-width: none;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.formTitleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.formTitle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #1b3a5f;\n  font-size: 26px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n  margin: 0;\n}\n\n.formCard {\n  border-radius: 12px !important;\n  border-color: #e8eaed !important;\n  background: #ffffff !important;\n  overflow: hidden;\n  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);\n}\n\n.formCardHeader {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e8eaed;\n  font-size: 15px;\n  font-weight: 500;\n  color: #3c4043;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #f8f9fa; /* gray-50 */\n}\n\n.formCardHeader svg {\n  color: #1b3a5f;\n}\n\n.formHeaderBadge {\n  margin-left: auto;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  background: #e8f0fe;\n  color: #1a73e8;\n}\n\n.formCardBody {\n  padding: 20px;\n}\n\n.permissionsCard {\n  border-radius: 12px !important;\n  border-color: #e8eaed !important;\n  background: #ffffff !important;\n  overflow: hidden;\n  box-shadow: 0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);\n  height: auto;\n  min-height: 520px;\n  display: flex;\n  flex-direction: column;\n}\n\n.permissionsHeader {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e8eaed;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #fafafa;\n}\n\n.permissionsTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1b3a5f;\n}\n\n.permissionsTitle svg {\n  color: #1b3a5f;\n}\n\n.permissionsHeaderRight {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.permissionsHeaderBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 16px;\n  background: #e3f2fd;\n  color: #1976d2;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.permissionsTopbar {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  background: #fafafa;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.permissionsTopbarRight {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.permissionsSelectedText {\n  color: #5f6368;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n/* Barra de status + Limpar Tudo (abaixo da lista de permissões) */\n.permissionsToolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  background: #f1f3f4;\n  border-top: 1px solid #e8eaed;\n}\n\n.permissionsToolbarInfo {\n  font-size: 14px;\n  color: #5f6368;\n  font-weight: 400;\n}\n\n.outlineMiniBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid #dadce0;\n  background: #ffffff;\n  color: #3c4043;\n  cursor: pointer;\n  font-size: 13px;\n  font-family: inherit;\n  font-weight: 500;\n}\n\n.outlineMiniBtn:disabled {\n  cursor: default;\n  opacity: 0.55;\n}\n\n.outlineMiniBtnIcon {\n  font-size: 18px !important;\n  width: 18px;\n  height: 18px;\n  color: #3c4043;\n  flex-shrink: 0;\n}\n\n.outlineMiniBtn:hover {\n  background: #f8f9fa;\n  border-color: #bdc1c6;\n}\n\n.actionFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: #ffffff;\n  border-top: 1px solid #e8eaed;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  box-shadow: 0 -2px 8px rgba(0,0,0,0.1);\n}\n\n.footerInfoBar {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  min-width: 0;\n}\n\n.footerStat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.footerStatLabel {\n  font-size: 12px;\n  color: #80868b;\n}\n\n.footerStatValue {\n  font-size: 13px;\n  color: #202124;\n  max-width: 380px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.footerActions {\n  display: flex;\n  gap: 12px;\n}\n\n@media (max-width: 1200px) {\n  .footerInfoBar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__dIpCo`,
	"containerSwitch": `styles_containerSwitch__RxcF4`,
	"labelSwitch": `styles_labelSwitch__mfdr1`,
	"pageWrapper": `styles_pageWrapper__HGjrx`,
	"pageRoot": `styles_pageRoot__opVtA`,
	"formPageWrapper": `styles_formPageWrapper__kLLMJ`,
	"formPageRoot": `styles_formPageRoot__oJlu0`,
	"inner": `styles_inner__RvPWq`,
	"mainPad": `styles_mainPad__HKSh0`,
	"breadcrumb": `styles_breadcrumb__mZbSY`,
	"crumbLink": `styles_crumbLink__8IHFl`,
	"crumbText": `styles_crumbText__-6mvk`,
	"breadcrumbSep": `styles_breadcrumbSep__qwyIi`,
	"pageHeader": `styles_pageHeader__ZgI+c`,
	"pageTitle": `styles_pageTitle__ZZnuM`,
	"pageTitleIcon": `styles_pageTitleIcon__vA3ke`,
	"statsGrid": `styles_statsGrid__F1hIn`,
	"statCard": `styles_statCard__84Ka4`,
	"statIcon": `styles_statIcon__0al4m`,
	"statInfo": `styles_statInfo__tdVLL`,
	"statValue": `styles_statValue__b9OZe`,
	"statLabel": `styles_statLabel__okPNL`,
	"contentCard": `styles_contentCard__YwLMS`,
	"mainCard": `styles_mainCard__8BmCp`,
	"filtersBar": `styles_filtersBar__3nrSb`,
	"filterGroup": `styles_filterGroup__aSZVQ`,
	"select": `styles_select__82XnX`,
	"searchInput": `styles_searchInput__jfrqM`,
	"groupsGrid": `styles_groupsGrid__MJfok`,
	"groupCard": `styles_groupCard__T8qFt`,
	"groupCardInactive": `styles_groupCardInactive__JTk2k`,
	"groupStatus": `styles_groupStatus__iYHpI`,
	"statusBadge": `styles_statusBadge__D2XSP`,
	"statusBadgeActive": `styles_statusBadgeActive__lI9+n`,
	"statusBadgeInactive": `styles_statusBadgeInactive__OZa1o`,
	"groupHeader": `styles_groupHeader__+MWJ+`,
	"groupIcon": `styles_groupIcon__VTQ1y`,
	"groupName": `styles_groupName__ThPXF`,
	"groupDesc": `styles_groupDesc__gEUfg`,
	"groupStats": `styles_groupStats__IZNEY`,
	"groupStat": `styles_groupStat__cER9C`,
	"groupStatsNivel": `styles_groupStatsNivel__WbO2I`,
	"accessLevelTag": `styles_accessLevelTag__8M-h5`,
	"groupActions": `styles_groupActions__kDHoi`,
	"emptyState": `styles_emptyState__gEJV8`,
	"paginationWrap": `styles_paginationWrap__vFdwa`,
	"formMain": `styles_formMain__1RE4S`,
	"formTitleRow": `styles_formTitleRow__4rVd3`,
	"formTitle": `styles_formTitle__XZHaH`,
	"formCard": `styles_formCard__34UWZ`,
	"formCardHeader": `styles_formCardHeader__YdmbE`,
	"formHeaderBadge": `styles_formHeaderBadge__OL+xW`,
	"formCardBody": `styles_formCardBody__wLovj`,
	"permissionsCard": `styles_permissionsCard__881QJ`,
	"permissionsHeader": `styles_permissionsHeader__ZpPdC`,
	"permissionsTitle": `styles_permissionsTitle__J1BEQ`,
	"permissionsHeaderRight": `styles_permissionsHeaderRight__GhpTj`,
	"permissionsHeaderBadge": `styles_permissionsHeaderBadge__Mr7Ok`,
	"permissionsTopbar": `styles_permissionsTopbar__PHIC9`,
	"permissionsTopbarRight": `styles_permissionsTopbarRight__ZbAbi`,
	"permissionsSelectedText": `styles_permissionsSelectedText__3eoA7`,
	"permissionsToolbar": `styles_permissionsToolbar__EIDA5`,
	"permissionsToolbarInfo": `styles_permissionsToolbarInfo__atRoN`,
	"outlineMiniBtn": `styles_outlineMiniBtn__qdjL6`,
	"outlineMiniBtnIcon": `styles_outlineMiniBtnIcon__u5KTi`,
	"actionFooter": `styles_actionFooter__NWQyK`,
	"footerInfoBar": `styles_footerInfoBar__zib5j`,
	"footerStat": `styles_footerStat__DK5ly`,
	"footerStatLabel": `styles_footerStatLabel__hiEkV`,
	"footerStatValue": `styles_footerStatValue__peLZ3`,
	"footerActions": `styles_footerActions__WHT7o`
};
export default ___CSS_LOADER_EXPORT___;
